// Locale-aware formatting (money, dates, percents) lives in `i18n` (useI18n().fmt).

// Get/set a value at a dotted path on a plain object (immutably).
export const getIn = (obj, path) => path.split('.').reduce((acc, key) => (acc == null ? undefined : acc[key]), obj)

export const setIn = (obj, path, value) => {
  const keys = path.split('.')
  const next = Array.isArray(obj) ? [...obj] : { ...obj }
  let cursor = next
  for (let i = 0; i < keys.length - 1; i++) {
    const key = keys[i]
    cursor[key] = cursor[key] == null ? {} : (Array.isArray(cursor[key]) ? [...cursor[key]] : { ...cursor[key] })
    cursor = cursor[key]
  }
  cursor[keys[keys.length - 1]] = value
  return next
}

// Empty input -> null, numeric input -> number.
export const toNumberOrNull = (value) => {
  if (value === '' || value === null || value === undefined) return null
  const n = Number(value)
  return Number.isFinite(n) ? n : null
}

export const downloadBlob = (blob, fileName) => {
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = fileName
  a.click()
  URL.revokeObjectURL(url)
}
